module.exports = __webpack_public_path__ + "pc/img/swiper_logo_08.e8729ceb.png";